import { Drawer } from 'braid-design-system';
import type React from 'react';
import type { IFilterQuestion } from 'src/stores/JobApplicationStore/FiltersStore/FiltersStore';
import { useStores } from 'src/utils/hooks/useStores';
import { FilterSideBarContent } from './FilterSideBarContent';
import { observer } from 'mobx-react';
import { StickyButtons } from './StickyButtons';
import { StickyButtonsFormView } from '../../common/StickyButtonsFormView';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';
import type { FilterFns } from './useFilters';

interface FilterDrawerProps {
  showDrawer: boolean;
  setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  useFiltersFns: FilterFns;
  selectedFilterCount: number;
  isMustHaveToggleSelected: boolean;
  questions: IFilterQuestion[];
}
export const FilterDrawer: React.FC<FilterDrawerProps> = observer(
  ({
    showDrawer,
    setShowDrawer,
    useFiltersFns,
    selectedFilterCount,
    isMustHaveToggleSelected,
    questions,
  }) => {
    const { isMobile } = useStores();
    const { t } = useTranslations(translations);

    return (
      <Drawer
        id="filter-drawer"
        width={isMobile ? 'large' : 'small'}
        title={t('Filters')}
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
      >
        <StickyButtonsFormView
          buttons={
            <StickyButtons
              onClose={() => setShowDrawer(false)}
              resetFilters={useFiltersFns.resetFilters}
              selectedFilterCount={selectedFilterCount}
            />
          }
          isStickyButtons={isMobile}
        >
          <FilterSideBarContent
            clearFilters={useFiltersFns.clearFilters}
            onMustHaveFilterToggled={useFiltersFns.onMustHaveFilterToggled}
            onParentFilterSelected={useFiltersFns.onParentFilterSelected}
            onFilterSelected={useFiltersFns.onFilterSelected}
            isMustHaveToggleSelected={isMustHaveToggleSelected}
            questions={questions}
          />
        </StickyButtonsFormView>
      </Drawer>
    );
  },
);
